/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddMentor = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        expertise: '',
        qualification: '',
        designation: '',
        company: '',
        bio: '',
        image: null
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.firstName || !formData.email || !formData.mobile) {
            toast.error("First Name, Email and Mobile are required!");
            return;
        }

        setLoading(true);
        const data = new FormData();
        for (const key in formData) {
            if (formData[key] !== null) {
                data.append(key, formData[key]);
            }
        }

        try {
            await postRequest('mentors/admin', data);
            toast.success('Mentor added successfully!');
            navigate('/mentors');
        } catch (error) {
            console.error('Failed to add mentor:', error);
            toast.error(error?.response?.data?.message || error?.message || 'Error occurred while creating mentor.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='container-fluid mt-5 mb-5'>
            <div className='mainheadig mx-4 mb-4'>
                <h4 className='text-white font-weight-bold'>Add Mentor Profile</h4>
            </div>
            <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                <div className='row'>
                    <div className='col-12 mb-3'>
                        <h5 className="border-bottom pb-2">Personal Details</h5>
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>First Name *</label>
                        <input type='text' name='firstName' className='form-control' value={formData.firstName} onChange={handleChange} required />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Last Name</label>
                        <input type='text' name='lastName' className='form-control' value={formData.lastName} onChange={handleChange} />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Email *</label>
                        <input type='email' name='email' className='form-control' value={formData.email} onChange={handleChange} required />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Mobile *</label>
                        <input type='text' name='mobile' className='form-control' value={formData.mobile} onChange={handleChange} required />
                    </div>
                    <div className='col-12 mb-3 mt-4'>
                        <h5 className="border-bottom pb-2">Professional Details</h5>
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Expertise / Domain</label>
                        <input type='text' name='expertise' className='form-control' value={formData.expertise} onChange={handleChange} placeholder="e.g. Marketing, AI, Finance" />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Qualification</label>
                        <input type='text' name='qualification' className='form-control' value={formData.qualification} onChange={handleChange} />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Designation</label>
                        <input type='text' name='designation' className='form-control' value={formData.designation} onChange={handleChange} />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Company</label>
                        <input type='text' name='company' className='form-control' value={formData.company} onChange={handleChange} />
                    </div>
                    
                    <div className='col-sm-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Biography / Profile</label>
                        <textarea name='bio' className='form-control' rows="3" value={formData.bio} onChange={handleChange} placeholder="About the mentor..."></textarea>
                    </div>

                    <div className='col-sm-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Profile Image</label>
                        <input type='file' name='image' className='form-control filebg' onChange={handleChange} accept="image/*" />
                    </div>
                </div>
                
                <div className='mt-4 text-right'>
                    <button type="button" className="btn btn-secondary mr-2" onClick={() => navigate('/mentors')}>Cancel</button>
                    <button type="submit" className='btn addbtn pl-4 pr-4' disabled={loading}>
                        {loading ? 'Creating...' : 'Add Mentor'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddMentor;
